import script from "./LiveSessionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSessionPage.vue?vue&type=script&setup=true&lang=js"

import "./LiveSessionPage.vue?vue&type=style&index=0&id=6bb74350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb74350"]])

export default __exports__